// extracted by mini-css-extract-plugin
module.exports = {"overlay":"_2WGDO"};